<div class="menu-mobile" [class.menu-mobile-submenu-open]="activeNavigationItem">
    <div class="menu-mobile-header">
        <div class="menu-mobile-arrow" (click)="activeNavigationItem = null">
            <svg class="icon menu-mobile-arrow-icon">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/s7-icons-20.svg#arrow-right"></use>
            </svg>
        </div>
        <div class="menu-mobile-logo">
            <a [routerLink]="['/']">
                <svg class="icon menu-mobile-logo-icon">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/s7-icons-20.svg#s7"></use>
                </svg>
            </a>
        </div>
        <div class="menu-mobile-cross" (click)="closeMobileMenu()"></div>
    </div>
    <div class="menu-mobile-body">
        <div class="menu-mobile-list">
            <div class="menu-mobile-item" *ngFor="let item of navigationItems">
                <a class="menu-mobile-item-title">{{ item.title }}</a>
                <a class="menu-mobile-subitem" (click)="activeNavigationItem = child" *ngFor="let child of item.items">
                    <div class="menu-mobile-subitem-text">{{ child.title }}</div>
                    <div class="menu-mobile-subitem-arrow">
                        <svg class="icon icon-20-chevron-right chevron-right-menu">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/s7-icons-20.svg#chevron-right"></use>
                        </svg>
                    </div>
                </a>
            </div>
        </div>
        <div class="menu-mobile-submenu">
            <div class="menu-mobile-item" *ngIf="activeNavigationItem">
                <div class="menu-mobile-item-title">{{ activeNavigationItem.title }}</div>
                <div class="menu-mobile-subitem" *ngFor="let item of activeNavigationItem.items">
                    <a class="link" [href]="item.url" [target]="item.openInNewWindow ? '_blank' : '_self'">
                        <div class="menu-mobile-subitem-text">{{ item.title }}</div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
